import { getAttr } from '../features/helpers/apiHelpers';

// maxLength (int)
// minLength (int)
// allowedFileTypes (list of strings)
// maxFileSize (int - in bytes)
// maxFileCount (int)
// canBeEmpty (bool)

const resolveValidationRules = (entity) => {
  const maxLength = getAttr(entity, 'maxLength');
  const minLength = getAttr(entity, 'minLength');
  const allowedFileTypes = getAttr(entity, 'allowedFileTypes');
  const maxFileCount = getAttr(entity, 'maxFileCount');
  const maxFileSize = getAttr(entity, 'maxFileSize');
  const canBeEmpty = getAttr(entity, 'canBeEmpty');

  const validationEntity = {
    maxLength,
    minLength,
    canBeEmpty,
    allowedFileTypes,
    maxFileSize,
    maxFileCount,
  };

  // Filtering out values that are not present for the validationRule in question
  return Object.fromEntries(
    Object.entries(validationEntity).filter(([k, v]) => v !== undefined),
  );
};

export { resolveValidationRules };
